export const ANY_QUESTIONS = 'Если у Вас есть вопросы, напишите администратору';
export const RESEARCH = 'Исследования';
export const YEAR = '© 2024';
export const EMAIL = 'edu@fond-igra.ru';
